export default __webpack_public_path__ + "static/media/slides.24e90f36.svg";